import { CreditApplicationErrors } from '../components/ApplicationProgress/ApplicationSubmitted/types'

export interface CreditApplication {
  id: string
  status: CreditApplicationStatus
  limit: number
  apr: CreditApr
  documents: Document[] | null
}

export interface CreditApplicationDetails extends CreditApplication {
  promotionCode?: string
}

export type CreditApr = {
  purchase: number
  cashAdvance: number
  agreementUrl: string
}

type Document = {
  id: string
  type: string
  fileFormat: string
}

export enum CreditApplicationStatus {
  ready = 'ready',
  waiting = 'waiting',
  rejected = 'rejected',
  accepted = 'accepted',
  review = 'review',
  errored = 'errored',
  expired = 'expired',
  declined = 'declined'
}

export const NOT_APPROVED = {
  type: CreditApplicationErrors.NOT_APPROVED,
  errorMessage: 'Application denied'
}

export const GENERIC = {
  type: CreditApplicationErrors.GENERIC,
  errorMessage: 'An error occured'
}

export const REVIEW_ERROR = {
  type: CreditApplicationErrors.REVIEW,
  errorMessage: 'Review is needed'
}

export type ApplicationDoc = {
  fileName: string
  fileType: string
  fileBase64String: string
}
